var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireProtectionSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_247)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 78.7997C52.981 78.8157 51.9754 78.5643 51.0836 78.0706L50.2086 77.5747C43.3931 73.7188 37.7231 68.1231 33.7774 61.3592C29.8318 54.5953 27.752 46.9054 27.7502 39.0747V38.6664C27.741 37.6336 28.0061 36.6168 28.5186 35.7201C29.031 34.8233 29.7724 34.0786 30.6669 33.5622L51.0836 22.0706C51.9703 21.5586 52.9763 21.2891 54.0002 21.2891C55.0242 21.2891 56.0301 21.5586 56.9169 22.0706L77.3336 33.5622C78.2281 34.0786 78.9694 34.8233 79.4819 35.7201C79.9943 36.6168 80.2595 37.6336 80.2502 38.6664V39.0747C80.2427 46.9111 78.154 54.605 74.1978 61.3694C70.2416 68.1339 64.5599 73.7263 57.7336 77.5747L56.8586 78.0706C55.984 78.5545 54.9997 78.8056 54.0002 78.7997ZM54.0002 27.1747L33.5836 38.6664V39.0747C33.5885 45.8738 35.4006 52.5493 38.8344 58.4175C42.2683 64.2857 47.2003 69.1357 53.1252 72.4706L54.0002 72.9664L54.8752 72.4706C60.8002 69.1357 65.7322 64.2857 69.166 58.4175C72.5998 52.5493 74.412 45.8738 74.4169 39.0747V38.6664L54.0002 27.1747Z",
    fill: "#8FB16A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9537 35.9822C51.4378 35.6704 50.7838 35.7254 50.3324 36.1199C49.8718 36.5051 49.7244 37.1473 49.9639 37.6977C51.576 41.4681 51.1523 43.2661 50.7561 44C50.3324 44.7706 49.6507 44.9724 49.3743 45.0183C48.6281 45.1559 48.0662 43.6881 48.057 43.6789C47.882 43.1652 47.4121 42.8074 46.8686 42.7616C46.3159 42.7249 45.8092 42.9909 45.5421 43.468C43.1008 47.8988 42.456 52.0545 43.6352 55.834C45.3578 61.3749 50.3969 63.9619 50.6088 64.0719C50.8022 64.1729 51.0233 64.2187 51.226 64.2187C51.5668 64.2187 51.8893 64.0995 52.1472 63.8702C52.571 63.494 52.7275 62.8977 52.5341 62.3657C52.1104 61.219 51.3642 57.8981 52.9118 56.2744C53.8606 55.2836 54.5239 54.3754 54.9753 53.5957C58.6786 59.3934 56.698 61.2098 56.6612 61.2556C56.6519 61.2556 56.6519 61.2648 56.6427 61.2648C56.0163 61.696 55.8689 62.5492 56.2926 63.173C56.7256 63.7968 57.5731 63.9619 58.2088 63.5399C58.2088 63.5307 58.218 63.5307 58.2272 63.5216C62.7136 60.3933 64.9244 56.7698 64.7954 52.7333C64.5191 43.734 52.4696 36.2942 51.9537 35.9822Z",
    fill: "#8FB16A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_247",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireProtectionSystem);
export default __webpack_public_path__ + "static/media/fireProtectionSystem.b8fc806a9dcb902abb34215117da1cfc.svg";
export { ForwardRef as ReactComponent };